import {
	filterTagsByAttribute, filterProducts, getAllProductTags, mapFilterBundles, mapFilterTags, filterBundlesByAttribute
} from "utils/filters";
import { FILTER_COLLECTION_PRODUCTS, ACTIVE_FILTERS } from "utils/action-types";
import getUrlParams from "helpers/get-url-params";

export const filterCollectionProducts = ({ products, handle, title }) =>
	(dispatch, getState) => {
		const { tags, bundles } = getState().filters;

		const settledTags = filterTagsByAttribute(tags, "isSettled");
		const activeTags = filterTagsByAttribute(tags, "isActive");

		const settledBundleProducts = filterBundlesByAttribute(bundles, "isSettled").flatMap(b => b.products);
		const activeBundleProducts = filterBundlesByAttribute(bundles, "isActive").flatMap(b => b.products);

		let mappedProducts = products?.map(product => ({
			...product,
			tags: product?.tags?.length ? product?.tags.map(t => t?.toLowerCase()) : null
		}));

		const activeProducts = filterProducts(mappedProducts, activeTags, activeBundleProducts);

		
		if (settledTags.length || settledBundleProducts.length)
			mappedProducts = filterProducts(mappedProducts, settledTags, settledBundleProducts);
		
		dispatch({
			type: FILTER_COLLECTION_PRODUCTS,
			handle,
			payload: {
				tags: getAllProductTags(activeProducts),
				products: activeProducts?.map(p => p.id),
				title
			}
		});
		return mappedProducts;
	};

export const searchProducts = (searchText, { products, title, handle, pureContent }) =>
	(dispatch) => {
		const matchedProducts = products?.filter(prod =>
			searchText.trim().split(" ").some(txt =>
				prod.title?.toLowerCase()?.includes(txt) ||
				prod.tags?.map(tag => tag?.toLowerCase())?.some(t => [txt, searchText].includes(t)) ||
				title?.toLowerCase()?.includes(txt) ||
				pureContent?.toLowerCase()?.includes(txt) ||
				prod.shortDescription?.toLowerCase()?.includes(txt)
			));

		dispatch({
			type: FILTER_COLLECTION_PRODUCTS,
			handle,
			payload: {
				tags: getAllProductTags(matchedProducts),
				products: matchedProducts.map(p => p.id),
				title
			}
		});
		return matchedProducts;
	};


export const initializeFilters = (filters) => (dispatch) => {
	const filterTags = mapFilterTags(filters);
	const filterBundles = mapFilterBundles(filters);

	const paramsConfig = [
		{ param: "tags", filters: filterTags },
		{ param: "bundles", filters: filterBundles }
	];

	paramsConfig.forEach(({ param, filters }) => {
		const paramValue = getUrlParams(param);
		if (paramValue) {
			paramValue.split(",").forEach(key => {
				if (Object.hasOwn(filters, key)) {
					filters[key].isActive = true;
					filters[key].isSettled = true;
				}
			});
		}
	});
	dispatch({ type: ACTIVE_FILTERS, payload: { tags: filterTags, bundles: filterBundles } });
};